import { css, unsafeCSS } from "lit";

/**
 * Visual treatment for `jha-dropdown-menu` so it reads as a panel (border, elevation, surface).
 * Must live in the same shadow root as the menu: document-level CSS does not pierce Lit shadows.
 * Import this into any Lit view that renders `jha-dropdown-menu` so panel tokens apply consistently.
 */
const JHA_DROPDOWN_MENU_PANEL_STYLES = `
jha-dropdown-menu {
  --jha-dropdown-menu-background-color: rgb(35, 35, 35);
  --jha-dropdown-menu-border-radius: 8px;
  --jha-dropdown-menu-box-shadow:
    0 4px 8px rgba(0, 0, 0, 0.17),
    0 16px 42px rgba(0, 0, 0, 0.3);
  --jha-dropdown-menu-item-background-color: transparent;
  --jha-dropdown-menu-item-background-hover: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-sizing: border-box;
}
jha-dropdown-menu[open-up] {
  box-shadow:
    0 -4px 8px rgba(0, 0, 0, 0.17),
    0 -16px 42px rgba(0, 0, 0, 0.3) !important;
}
@media (prefers-color-scheme: light) {
  jha-dropdown-menu {
    --jha-dropdown-menu-background-color: #f6f8fb;
    --jha-dropdown-menu-border-radius: 8px;
    --jha-dropdown-menu-box-shadow:
      0 4px 12px rgba(37, 49, 62, 0.06),
      0 16px 40px rgba(37, 49, 62, 0.11);
    --jha-dropdown-menu-item-background-hover: rgba(37, 49, 62, 0.04);
    border: 1px solid rgba(37, 49, 62, 0.1);
  }
  jha-dropdown-menu[open-up] {
    box-shadow:
      0 -4px 12px rgba(37, 49, 62, 0.06),
      0 -16px 40px rgba(37, 49, 62, 0.11) !important;
  }
}
`.trim();

export const jhaDropdownMenuPanelStyles = css`
  ${unsafeCSS(JHA_DROPDOWN_MENU_PANEL_STYLES)}
`;

/** Plain CSS for injection into third-party shadow roots (e.g. jha-advanced-table). */
export const jhaDropdownMenuPanelStylesText = JHA_DROPDOWN_MENU_PANEL_STYLES;
